
import { Component, Prop, Vue } from "vue-property-decorator";
import GuestsTab from "@/components/GuestsTab.vue";

@Component({
  components: { GuestsTab },
})
export default class KeyGroupGuests extends Vue {

  @Prop({default: null})
  public keyGroup: any;
}
